var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSchool(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_723_5999",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 150,
    height: 150
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_723_5999)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.25 100V63.125L80.9376 90.4687C79.0626 91.5104 77.0835 92.0312 75.0001 92.0312C72.9168 92.0312 70.9376 91.5104 69.0626 90.4687L16.2501 61.7187C15.1043 61.0937 14.297 60.3125 13.8282 59.375C13.3595 58.4375 13.1251 57.3958 13.1251 56.25C13.1251 55.1042 13.3595 54.0625 13.8282 53.125C14.297 52.1875 15.1043 51.4062 16.2501 50.7812L69.0626 22.0312C70.0001 21.5104 70.9637 21.1198 71.9532 20.8594C72.9428 20.599 73.9585 20.4688 75.0001 20.4688C76.0418 20.4688 77.0574 20.599 78.047 20.8594C79.0366 21.1198 80.0001 21.5104 80.9376 22.0312L140.469 54.5312C141.511 55.0521 142.318 55.8073 142.891 56.7969C143.464 57.7865 143.75 58.8542 143.75 60V100C143.75 101.771 143.151 103.255 141.953 104.453C140.755 105.651 139.271 106.25 137.5 106.25C135.729 106.25 134.245 105.651 133.047 104.453C131.849 103.255 131.25 101.771 131.25 100ZM69.0626 127.969L37.8126 111.094C35.7293 109.948 34.1147 108.385 32.9689 106.406C31.823 104.427 31.2501 102.292 31.2501 100V76.25L69.0626 96.7187C70.9376 97.7604 72.9168 98.2812 75.0001 98.2812C77.0835 98.2812 79.0626 97.7604 80.9376 96.7187L118.75 76.25V100C118.75 102.292 118.177 104.427 117.031 106.406C115.886 108.385 114.271 109.948 112.188 111.094L80.9376 127.969C80.0001 128.49 79.0366 128.88 78.047 129.141C77.0574 129.401 76.0418 129.531 75.0001 129.531C73.9585 129.531 72.9428 129.401 71.9532 129.141C70.9637 128.88 70.0001 128.49 69.0626 127.969Z",
    fill: "#CDBCAD"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchool);
export default __webpack_public_path__ + "static/media/school.ed67a15e44fc8f6c399df769ab0300eb.svg";
export { ForwardRef as ReactComponent };